
let baseUrl = process.env.NODE_ENV === "development" ? '/api' : ''

export default baseUrl